// import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { useRouteError } from 'react-router';
import ErrorFallBack from '../ErrorFallBack/index.tsx';

export const ErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    if (error) {
      // Sentry error capture is temporarily disabled.
      console.error('Route error boundary captured an error', error);
    }
  }, [error]);

  return <ErrorFallBack />;
};
